/**
 * PrimitiveCompositionPage - Primitive composition dashboard
 *
 * Surfaces the PrimitiveCompositionDashboard from @ferp/workflow-forms for architect users.
 * Provides visualization and management of 25-primitive compositions.
 *
 * Route: /admin/primitive-composition
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconBoxMultiple } from '@tabler/icons-react';

import { PrimitiveCompositionDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function PrimitiveCompositionPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="violet">
            <IconBoxMultiple size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Primitive Composition</Title>
            <Text size="sm" c="dimmed">
              Visualization and management of 25-primitive compositions
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <PrimitiveCompositionDashboard tenant={tenant?.id ?? ''} />
    </Container>
  );
}

export default PrimitiveCompositionPage;
